import type { Key, MutatorCallback } from 'swr'

import type { InvoicesSummary } from '../api'

type GlobalMutate = (
  key?: Key | MutatorCallback,
  data?: unknown,
  opts?: { revalidate?: boolean },
) => Promise<unknown>

const isInvoiceSummaryKey = (key: Key): key is string =>
  typeof key === 'string' && key.startsWith('/api/invoices/summary')

export const revalidateInvoiceSummaryCaches = (mutate: GlobalMutate) =>
  mutate(
    (key) => isInvoiceSummaryKey(key),
    (current: InvoicesSummary | undefined) => current,
    { revalidate: true },
  )

export const applyPaidToInvoiceSummaryOptimistic = (
  mutate: GlobalMutate,
  invoiceTotal: number,
) =>
  mutate(
    (key) => isInvoiceSummaryKey(key),
    (current: InvoicesSummary | undefined) => {
      if (!current) return current
      return {
        ...current,
        paidAmount: current.paidAmount + invoiceTotal,
        paidCount: current.paidCount + 1,
        dueAmount: current.dueAmount - invoiceTotal,
        dueCount: current.dueCount - 1,
      }
    },
    { revalidate: false },
  )
